var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVimeo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9891 11.3992C26.8901 13.5367 25.3941 16.4634 22.5011 20.1794C19.5091 24.0598 16.9791 26 14.911 26C13.6295 26 12.546 24.8162 11.655 22.4539C11.061 20.289 10.4725 18.1186 9.87852 15.9537C9.21852 13.5915 8.51452 12.4077 7.76101 12.4077C7.59601 12.4077 7.01851 12.7529 6.034 13.4435L5 12.1117C6.0835 11.158 7.15601 10.2044 8.21201 9.25072C9.65852 8.00658 10.7475 7.34889 11.468 7.28312C13.1785 7.1187 14.2345 8.2861 14.6305 10.7908C15.0595 13.4874 15.351 15.17 15.5215 15.8277C16.0166 18.0693 16.5556 19.1874 17.1496 19.1874C17.6116 19.1874 18.2991 18.4584 19.2231 17.0115C20.1471 15.5591 20.6366 14.452 20.7026 13.6956C20.8346 12.4405 20.3396 11.8157 19.2231 11.8157C18.6951 11.8157 18.1561 11.9363 17.5951 12.1775C18.6786 8.62591 20.7466 6.91043 23.7936 7.0036C26.0541 7.06937 27.1211 8.53274 26.9891 11.3937V11.3992Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.d30cbd715a1d76a5c774b1670d367105.svg";
export { ForwardRef as ReactComponent };